export default {
    props: {
        values: {
            type: Array,
            default: undefined,
            kComposite: 'values'
        }, 
        axis: {
            type: String,
            default: undefined,
            kComposite: 'axis'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotMeasure/Measures.js